import React, { useEffect, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { useDispatch, useSelector } from "react-redux";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import InputKendoRct from "../../control-components/input/input";
import { SELECTED_ANNOUNCEMENT_FILTER } from "../../actions/authActions";
import { clinicService } from "../../services/clinicService";
import { AnnouncementServices } from "../../services/announcementService";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import Loader from "../../control-components/loader/loader";
import moment from "moment";
import { Error } from "@progress/kendo-react-labels";
import { GET_ALL_CLINIC } from "../../actions";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";

const SearchModel = ({ fetchFromParent, onClear,fields,setFields, keyword, title, setKeyword, setTitle }) => {
  const dispatch = useDispatch();
  const announcementFiter = useSelector((state) => state?.announcementFiter)
  const [loading, setLoading] = useState(false);
  const [allClinic, setAllClinic] = useState([]);
  const [errors, setErrors] = useState("");
  const [staffError, setStaffError] = useState(false);
  const [roles, setRoles] = useState([]);
  const [statesData, setStatesData] = useState([]);

  useEffect(() => {
    getAllClinic();
    getAllStates();
    getRoles();
  }, []);

  const getAllClinic = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.ALL_CLINIC)
      .then((result) => {
        dispatch({
          type: GET_ALL_CLINIC,
          payload: result.resultData,
        });
        setLoading(false);
        let staffAuditActions = result.resultData;
        setAllClinic(staffAuditActions);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const getRoles = async () => {
    setLoading(true);
    ApiHelper.getRequest(ApiUrls.ROLES + 1)
      .then((result) => {
        setLoading(false);
        let roles = result.resultData;
        setRoles(roles);
      })
      .catch((error) => {
        NotificationManager.error(error.message);
      });
  };

  const getAllStates = async () => {
    setLoading(true);
    await clinicService
      .getAllClinicStates()
      .then((result) => {
        setStatesData(result.resultData)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NOTIFICATION_MESSAGE.error(error);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setFields({
      ...fields,
      [name]: value,
    });
    dispatch({
      type: SELECTED_ANNOUNCEMENT_FILTER,
      payload: {
        ...fields,
        [name]: value,
      },
    });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (
      fields.dateStart &&
      fields.dateEnd &&
      moment(fields.dateEnd).isBefore(moment(fields.dateStart))
    ) {
      formIsValid = false;
      errors.dateEndLessThanStart = "End date must be after or equal to start date";
    }
  
    setErrors(errors); 
    return formIsValid;
  };
  

  const handleSearch = () => {
    
      if (handleValidation()){
        setLoading(true);
        const data = {
            clinicId: fields.clinicId?.id,
            roleId: fields.roleId?.id,
            stateId: fields.stateId?.id,
            title: title,
            dateStart: moment(fields.dateStart).format("M/D/YYYY"),
            dateEnd: moment(fields.dateEnd).format("M/D/YYYY"),
            keyword: keyword,
          };
        AnnouncementServices.getAnnouncements(data)
        .then((result) => {
          setLoading(false);
          fetchFromParent(result.resultData);
        })
        .catch((error) => {
          setLoading(false);
          NotificationManager.error(error.message);
        });
      }

  };

  const handleClear = () => {
    dispatch({
      type: SELECTED_ANNOUNCEMENT_FILTER,
      payload: {
        clinicId: null,
        roleId: null,
        stateId: null,
        dateStart: moment().subtract(3, "days").startOf("day").format("M/D/YYYY"),
        dateEnd: moment().endOf("day").format("M/D/YYYY"),
      },
    });
    setKeyword('');
    setTitle('');
    onClear(true);
  };
  return (
    <>

      <div class="col-md-12 col-sm-12 ">
      {loading === true && <Loader />}
        <div class="row ">
          <div className="col-md-12 col-lg-3 col-12 mb-3 edit-Service-popup">
            <DropDownKendoRct
              validityStyles={staffError}
              label="Master Clinic Name"
              onChange={handleChange}
              data={allClinic}
              value={fields.clinicId}
              textField="clinicName"
              name="clinicId"
              error={fields.clinicId === "" && errors.clinicId}
              required={true}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3 edit-Service-popup">
            <DropDownKendoRct
                validityStyles={staffError}
                label="Roles"
                onChange={handleChange}
                data={roles}
                value={fields.roleId}
                textField="roleName"
                name="roleId"
                error={fields.roleId === "" && errors.roleId}
                required={true}
                />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3 edit-Service-popup">
            <DropDownKendoRct
                validityStyles={staffError}
                label="States"
                onChange={handleChange}
                data={statesData}
                value={fields.stateId}
                textField="stateName"
                name="stateId"
                error={fields.stateId === "" && errors.stateId}
                required={true}
                />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={title}
              onChange={(e) => {setTitle(e.target.value)}}
              name="title"
              label="Title"
              className="form-control"
              placeholder={"Enter to search by title"}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3">
            <InputKendoRct
              value={keyword}
              onChange={(e) => {setKeyword(e.target.value)}}
              name="keyword"
              label="Keyword"
              className="form-control"
              placeholder={"Enter to search by keyword"}
            />
          </div>
          <div className="col-md-12 col-lg-3 col-12 mb-3 mt-2 date-field edit-Service-popup">
          <DatePickerKendoRct
            value={new Date(fields.dateStart)}
            name="dateStart"
            onChange={handleChange}
            label="Start Date"
          />
        </div>
        <div className="col-md-12 col-lg-3 col-12 mb-3 mt-2 date-field edit-Service-popup">
          <DatePickerKendoRct
            value={new Date(fields.dateEnd)}
            onChange={handleChange}
            name="dateEnd"
            label="End Date"
            />
            <Error>{errors.dateEndLessThanStart}</Error>
          </div>
          
        </div>
      </div>
      <div class="col-md-12 col-sm-12 mt-3">
        <div class="row">
          <div class="col-md-12">
            <div className="btn-align-cus d-flex justify-content-start ">
              <button className="green-btn btn-primary" onClick={handleSearch}>
                Filter
              </button>
              <button
                className="btn text-grey ml-3"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchModel;